import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import isEmpty from 'lodash/isEmpty'

export const initialState = {
  locale: 'en',
  dictionary: {}
}

const i18nL10n = createSlice({
  name: 'i18nL10n',
  initialState,
  reducers: {
    SET_LOCALE: (state, { payload }) => {
      state.locale = payload
    },
    SET_DICTIONARY: (state, { payload }) => {
      state.dictionary = payload
    }
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action) => {
      if (action.payload.i18nL10n) {
        state.dictionary = !isEmpty(action.payload.i18nL10n.dictionary)
          ? action.payload.i18nL10n.dictionary
          : state.dictionary
      }
    })
  }
})

export default i18nL10n

export const { actions: i18nL10nActions } = i18nL10n

export const i18nL10nSelectors = {
  selectLocale: state => state.i18nL10n.locale,
  selectDictionary: state => state.i18nL10n.dictionary,
  selectI18nL10n: state => state.i18nL10n
}
